export default __webpack_public_path__ + "static/media/ToyotaDisplay-Regular.f37a7a83.svg";